module.exports = __webpack_public_path__ + "static/media/rogue2_preview.61204c2c.jpg";